import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageHero from "@/components/PageHero";
import ContactChannels from "@/components/ContactChannels";
import ContactForm from "@/components/ContactForm";
import ContactNextSteps from "@/components/ContactNextSteps";
import RevenueSimulator from "@/components/RevenueSimulator";
import ContactInfoCard from "@/components/ContactInfoCard";
import ContactQuickFAQ from "@/components/ContactQuickFAQ";
import SEO from "@/components/SEO";
import { CONTACT } from "@/lib/data";

const CONTACT_JSONLD = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Contact, Terre et Mer Conciergerie",
  url: "https://terreetmer-conciergerie.fr/contact",
  contactOption: "TollFree",
  contactType: "customer service",
  telephone: CONTACT.phone,
  email: CONTACT.email,
  availableLanguage: ["French", "English"],
  areaServed: "FR-BRE",
};

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo === "simulator") {
      setTimeout(() => {
        const el = document.getElementById("simulator");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
    }
  }, [location.state]);

  return (
    <div data-testid="page-contact">
      <SEO
        title="Contact & rendez-vous, Conciergerie Airbnb Bretagne"
        description="Contactez Terre et Mer Conciergerie : formulaire, téléphone 02 55 99 66 25 ou RDV Calendly 15 min. Étude gratuite de votre logement sous 24h."
        keywords="contact conciergerie Bretagne, rendez-vous conciergerie Airbnb, simulation revenus Airbnb Saint-Malo, étude location courte durée Bretagne"
        jsonLd={CONTACT_JSONLD}
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Contact", path: "/contact" },
        ]}
      />

      {/* === ACT 1, HERO : promesse === */}
      <PageHero
        overline="Contact"
        title="Discutons du potentiel"
        italic="de votre logement"
        description="Étude gratuite et personnalisée, réponse sous 24h. Notre équipe locale vous accompagne en Bretagne et sur la Côte d'Émeraude."
        image="/images/team-contact.jpg"
      />

      {/* === ACT 2, 3 CHANNELS : choix du canal === */}
      <ContactChannels />

      {/* === ACT 3, MAIN FORM (recommended channel) === */}
      <ContactForm />

      {/* === ACT 4, TIMELINE : que se passe-t-il après ? === */}
      <ContactNextSteps />

      {/* === ACT 5, REVENUE SIMULATOR (alternative) === */}
      <RevenueSimulator />

      {/* === ACT 6, DIRECT CONTACT INFO === */}
      <ContactInfoCard />

      {/* === ACT 7, QUICK FAQ : anti-objection === */}
      <ContactQuickFAQ />
    </div>
  );
};

export default Contact;
